<template>
    <b-card no-body bg-variant="light">
        <div class="p-3">
            <b-row>
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group :label="`*${$t(`평가 주최사`)}`" label-for="input-new-site-client" class="mb-lg-0">
                        <b-dropdown id="input-new-site-client" :text="clientLabel(selected_client)"
                                    menu-class="py-0 my-0" block>
                            <b-dropdown-item
                                v-for="(_client, _client_idx) in clients"
                                :key="`new-site-clients-${_client_idx}`"
                                :class="[{ 'bgray-200': selected_client && selected_client.value === _client.value }]"
                                @click="selected_client = _client"
                            >
                                {{ clientLabel(_client) }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group :label="`*${$t(`기업명`)}`" label-for="input-new-site-company_name" class="mb-lg-0">
                        <b-form-input id="input-new-site-company_name"
                                      v-model="form.company_name"
                                      :disabled="loading"
                                      trim
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group :label="`*${$t(`소재지`)}`" label-for="input-new-site-country" class="mb-lg-0">
                        <b-form-select id="input-new-site-country"
                                       v-model="form.company_country"
                                       :options="company_country_options"
                                       :text-field="$i18n.locale === 'ko' ? 'text' : 'text_en'"
                                       value-field="value"
                                       :disabled="loading"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group :label="`*${$t(`사업자등록번호`)}`" label-for="input-new-site-company_code" class="mb-lg-0">
                        <b-form-input id="input-new-site-company_code"
                                      v-model="form.company_code"
                                      :placeholder="$t(`평가 대상 사업장의 사업자등록번호`)"
                                      trim
                                      :disabled="loading"
                        />
                    </b-form-group>
                </b-col>
                <b-col v-show="step1_message" cols="12">
                    <div class="bg-warning rounded mt-3 p-3">
                        <p class="fw-500 gray-700 mb-0">{{ $t(step1_message) }}</p>
                    </div>
                </b-col>
                <b-col cols="12" class="text-right">
                    <b-btn variant="primary" :disabled="loading" @click="verify">
                        <b-spinner v-if="loading" small class="mr-2"/>
                        {{ $t('기업 확인') }}
                    </b-btn>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
// ?nwas 신규 사업장 직접 등록 폼 — custom hmc-theme/hyundai-v2 모놀리스의
// validateStep1_ProjectCompany_new 를 신세대 트리 위에 공용화한 것 (2026-09-02).
// 서브도메인별 On/Off: tenant.register.newSiteProjectCode 가 있는 테넌트에서만 마운트된다.
import {company_country_options} from '@/components/auth/Register/_SubComponents/data.js';

export default {
    name: 'NewSiteRegisterForm',
    props: {
        clients: {
            type: Array,
            required: true,
        },
        projectCode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            step1_message: null,
            selected_client: null,
            form: {
                company_name: null,
                company_country: null,
                company_code: null,
            },
        };
    },
    computed: {
        company_country_options() {
            return company_country_options;
        },
    },
    created() {
        // placeholder(value null) 를 건너뛴 첫 실제 주최사를 기본 선택
        this.selected_client = this.clients.find(c => c.value) || this.clients[0];
    },
    methods: {
        clientLabel(client) {
            const label = client && client.label;
            if (!label) return '';
            if (typeof label === 'string') return this.$t(label);
            return label[this.$i18n.locale] || label.ko;
        },
        // 모놀리스 CompanyformCheck 신규 분기 미러
        formCheck() {
            if (!this.selected_client || !this.selected_client.value) {
                alert(this.$t('"ESG 평가 주최 원청사"를 선택해주세요.'));
                return false;
            }
            const empty = v => v == null || String(v).trim() === '';
            if (empty(this.form.company_name) && empty(this.form.company_code) && empty(this.form.company_country)) {
                alert(this.$t('기업명, 소재지, 사업자등록번호를 모두 입력 및 선택해주세요.'));
                return false;
            }
            if (this.$i18n.locale === 'ko') {
                if (empty(this.form.company_code) && (empty(this.form.company_name) || this.form.company_name.length < 2)) {
                    alert(this.$t('기업명을 2자 이상의 적어 주십시오.'));
                    return false;
                }
                if (empty(this.form.company_code) || this.checkCorporateRegiNumber(this.form.company_code) !== true) {
                    alert(this.$t('유효하지 않은 사업자번호입니다. \n 3자 이상의 사업자등록번호를 정확히 입력하여 주십시오.'));
                    return false;
                }
            }
            return true;
        },
        checkCorporateRegiNumber(number) {
            const numberMap = number.replace(/-/gi, '').split('').map(d => parseInt(d, 10));
            if (numberMap.length === 10) {
                let keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
                let chk = 0;
                keyArr.forEach(function (d, i) {
                    chk += d * numberMap[i];
                });
                chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10);
                return Math.floor(numberMap[9]) === ((10 - (chk % 10)) % 10);
            }
            return false;
        },
        async verify() {
            if (!this.formCheck()) return;

            this.loading = true;
            this.step1_message = null;

            try {
                const response = await this.$axios.get('/register/verification_project_company', {
                    params: {
                        project_code: this.projectCode,
                        company_name: this.form.company_name,
                        company_code: this.form.company_code,
                        company_country: this.form.company_country,
                        lang: this.$i18n.locale,
                    }
                });

                const {company, vendor, hd_corporate} = response.data;

                if (vendor) {
                    // 이미 협력사 평가 대상인 기업 → 그 평가신청으로 전환
                    alert(`${vendor.company_name} 기업은 ${vendor.project_code} 프로젝트 - 협력사 평가 대상 기업으로, 해당 평가신청으로 이동하겠습니다.`);
                    this.$emit('vendor-found', vendor.vendor_code);
                    return;
                }

                // 기존/신규 기업 정보로 미검증 vendor 를 합성해 다음 단계로
                const resolved_name = (company && company.company_name) || this.form.company_name;
                const resolved_code = (company && company.company_code) || this.form.company_code;
                let _country = this.form.company_country;
                if (this.form.company_country && this.$i18n.locale === 'ko') {
                    const _idx = company_country_options.findIndex(({text_en}) => text_en === this.form.company_country);
                    if (_idx >= 0) _country = company_country_options[_idx].text;
                }

                this.$emit('company-resolved', {
                    company: {
                        id: company && company.id,
                        company_name_dip: resolved_name,
                        company_name_en_dip: resolved_name,
                        company_name: resolved_name,
                        hd_corporate: hd_corporate,
                        country_en: this.form.company_country,
                        country: _country,
                        corporate_code: null,
                        company_code: resolved_code,
                        duns_number: null,
                    },
                    company_name: resolved_name,
                    project_code: this.projectCode,
                    company_code: resolved_code,
                    vendor_code: null,
                    validated: false,
                });
            } catch (error) {
                const data = getErrorMessage(error, '');
                if (data === 'Not_Found_Project') {
                    this.step1_message = '존재하지 않는 프로젝트 코드입니다. 평가신청 링크로 재진입해주시거나 평가 주관기관에 문의해주시기 바랍니다.';
                } else if (data === 'Not_Valid_Project') {
                    this.step1_message = '유효하지 않는 프로젝트 코드입니다. 평가신청 링크로 재진입해주시거나 평가 주관기관에 문의해주시기 바랍니다.';
                } else {
                    this.step1_message = '알 수 없는 에러가 발생했습니다. 잠시 후 다시 시도해주세요.';
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
